import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

// Extracted from CompliancePage.jsx's 3-badge grid so it can be reused on
// other pages (e.g. CorporatePartnersPage) without duplicating it.
//
// `validUntilLabel` is optional — CompliancePage doesn't pass it, so it
// keeps using the translated "Valid until" copy exactly as before. Pages
// with English-only content (which don't want a translated string mixed
// into otherwise-hardcoded English body copy) can pass a plain string
// instead.
const ComplianceBadge = ({ icon: Icon, title, registration, validUntil, validUntilLabel, description }) => {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="bg-white border border-slate-200 p-8 card-hover"
    >
      <div className="flex items-start gap-4 mb-6">
        <div className="p-4 bg-navy text-gold">
          <Icon size={28} strokeWidth={1.5} />
        </div>
        <div>
          <h3 className="font-outfit text-xl font-semibold text-navy">{title}</h3>
          {registration && (
            <p className="text-gold text-sm font-semibold mt-1">{registration}</p>
          )}
          {validUntil && (
            <p className="text-slate-500 text-xs mt-1">{validUntilLabel || t("compliance.badges.validUntilLabel")} {validUntil}</p>
          )}
        </div>
      </div>
      <p className="text-slate-600 leading-relaxed">{description}</p>
    </motion.div>
  );
};

export default ComplianceBadge;
